




























import { usePageInfo } from '@/store'
import { omega } from '@didi/driver-biz-sdk'
import { computed, defineComponent, ref, watch } from '@vue/composition-api'
export default defineComponent({
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  setup(props, { emit }) {
    const store = usePageInfo()
    const isDriverDay = computed(() => store.isDriverDay)
    const selected = ref(0)
    watch(() => props.value, (newV) => {
      if (newV !== selected.value) {
        selected.value = newV
      }
    }, {
      immediate: true
    })
    function clickTab(index: number) {
      omega.trackEvent(index === 0 ? 'am_c_insure_medical_landpage_subsidy_ck' : 'am_c_insure_medical_landpage_expense_ck', {
        selected_tab: index
      })
      selected.value = index
      emit('input', index)
    }
    return {
      selected,
      clickTab,
      isDriverDay
    }
  }
})
